import render4849 from "../assest/GreenHome/ApartmentRenders/48-49.jpg";
import render50 from "../assest/GreenHome/ApartmentRenders/50.jpg";
import render60 from "../assest/GreenHome/ApartmentRenders/60.jpg";
import render62one from "../assest/GreenHome/ApartmentRenders/62-1.jpg";
import render62two from "../assest/GreenHome/ApartmentRenders/62-2.jpg";
import render80 from "../assest/GreenHome/ApartmentRenders/80.jpg";
import render87 from "../assest/GreenHome/ApartmentRenders/87.jpg";
import render115 from "../assest/GreenHome/ApartmentRenders/115.jpeg";
import render119 from "../assest/GreenHome/ApartmentRenders/119.jpg";
import render125One from "../assest/GreenHome/ApartmentRenders/125-1.jpg";
import render127one from "../assest/GreenHome/ApartmentRenders/127-1.jpg";
import render127three from "../assest/GreenHome/ApartmentRenders/127-3.jpg";
import render127four from "../assest/GreenHome/ApartmentRenders/127-4.jpg";
import render138 from "../assest/GreenHome/ApartmentRenders/138.jpg";
import render93 from "../assest/GreenHome/ApartmentRenders/93.jpeg";
import { NikeaApartmentRenders } from "../assest/Nikea/floorRenders/paths";

export const coordinatesOnTheFloor = [
  {
    id: 1,
    position: "მარჯვენა კუთხის ქვედა მარცხენა ბინა",
    coordinates:
      "M872,392 L990,652 L984,655 L1005,705 L994,728 L904,760 L887,722 L842,687 L773,522 L780,496 L789,493 L760,430 Z",
  },
  {
    id: 2,
    position: "მარჯვენა კუთხის ქვედა ბინა",
    coordinates:
      "M895,442 L990,652 L984,655 L1005,705 L994,728 L1009,762 L1015,759 L1030,793 L1174,742 L1184,733 L1166,699 L1180,682 L1135,592 L1218,562 L1224,552 L1220,544 L1242,536 L1262,510 L1210,417 L1011,484 L977,415 Z",
  },
  {
    id: 3,
    position: "მარჯვენა კუთხის შუა ბინა",
    coordinates:
      "M938,428 L977,415 L1011,484 L1210,417 L1234,464 L1248,459 L1255,446 L1216,367 L1300,338 L1316,312 L1270,228 L902,350 Z",
  },
  {
    id: 4,
    position: "მარჯვენა კუთხის ზედა ბინა",
    coordinates:
      "M902,350 L1270,228 L1259,208 L1251,220 L1213,151 L1222,133 L1178,52 L1161,59 L1156,46 L1036,84 L1043,100 L1035,102 L1075,180 L1019,199 L1034,231 L872,284 Z",
  },
  {
    id: 5,
    position: "მარცხნიდან მეორე კიბის მერე ბინა",
    coordinates:
      "M872,284 L1034,231 L1019,199 L1075,180 L1035,102 L1043,100 L1028,72 L960,93 L954,113 L906,128 L898,114 L824,138 L820,157 L784,168 L777,152 L758,159 L825,299 Z",
  },
  {
    id: 6,
    position: "მარცხნიდან კიბის მერე მეოთხე ბინა, მარჯვენა კიბემდე პირველი",
    coordinates:
      "M516,240 L584,216 L592,231 L634,217 L637,200 L657,195 L718,335 L571,384 Z",
  },
  {
    id: 7,
    position: "მარჯვნიდან პირველი ბინა მწკრივში",
    coordinates:
      "M662,591 L724,571 L725,557 L720,540 L773,522 L780,496 L774,482 L780,480 L758,430 L872,392 L846,333 L590,422 Z",
  },
  {
    id: 8,
    position: "მარჯვნიდან მეორე ბინა მწკრივში",
    coordinates: "M515,643 L662,591 L590,422 L449,468 Z",
  },
  {
    id: 9,
    position: "მარჯვნიდან მესამე ბინა მწკრივში",
    coordinates: "M368,695 L515,643 L449,468 L305,515 Z",
  },
  {
    id: 10,
    position: "მარჯვნიდან მეოთხე ბინა მწკრივში",
    coordinates: "M101,788 L368,695 L305,515 L47,603 Z",
  },
  {
    id: 11,
    position: "მარჯვნიდან მეხუთე ბინა მწკრივში",
    coordinates: "M-50,842 L101,788 L47,603 L-107,653 Z",
  },

  {
    id: 12,
    position: "მარცხნიდან პირველი ბინის ქვედა ნაწილი",
    coordinates:
      "M-300,714 L-265,865 L-253,873 L-247,900 L-239,904 L-50,840 L-106,652 L-182,676 L-178,690 L-262,718 L-266,702 Z",
  },
  {
    id: 13,
    position: "მარცხნიდან პირველი ბინის ზედა ნაწილი",
    coordinates:
      "M-345,545 L-315,660 L-305,668 L-295,710 L-300,714 L-266,702 L-262,718 L-178,690 L-192,640 L-116,614 L-162,460 L-236,485 L-232,498 L-285,514 L-295,500 L-312,505 L-300,522 L-340,533 Z",
  },
  {
    id: 14,
    position: "მარცხნიდან ზემო პირველი პატარა ბინა კიბის უჯრედამდე",
    coordinates:
      "M-161,458 L-136,450 L-126,464 L-83,450 L-88,434 L-12,409 L34,565 L-118,613 Z",
  },
  {
    id: 15,
    position: "მარცხნიდან კიბის მერე პირველი ბინა",
    coordinates:
      "M96,375 L171,352 L176,368 L223,353 L219,337 L238,330 L288,476 L144,524 Z",
  },
  {
    id: 16,
    position: "მარცხნიდან კიბის მერე მეორე ბინა",
    coordinates:
      "M238,330 L311,305 L316,320 L360,305 L356,291 L378,284 L430,430 L288,476 Z",
  },
  {
    id: 17,
    position: "მარცხნიდან კიბის მერე მესამე ბინა",
    coordinates:
      "M379,284 L447,262 L454,276 L494,263 L493,247 L515,240 L570,384 L431,430 Z",
  },
  {
    id: 18,
    position: "მარცხენა ერთიანი ბინა",
    coordinates:
      "M-345,545 L-265,865 L-253,873 L-247,900 L-240,904 L-50,840 L-162,460 L-236,485 L-232,498 L-285,514 L-295,500 L-312,505 L-300,522 L-340,533 Z",
  },
  {
    id: 19,
    position: "2 სართულზე 1-7 გაერთიანებული ბინა",
    coordinates:
      "M872,392 L990,652 L984,655 L1005,705 L994,728 L904,760 L887,722 L842,687 L773,522 L720,540 L725,557 L724,571 L662,591 L590,422 L846,333 Z",
  },
  {
    id: 20,
    position: "8 სართულზე მარცხნიდან მეორე კიბის მერე ბინის დიდი ნაწილი",
    coordinates:
      "M902,350 L1270,228 L1259,208 L1251,220 L1213,151 L1222,133 L1178,52 L1161,59 L1156,46 L1036,84 L1028,72 L960,93 L954,113 L906,128 L898,114 L966,251 L872,284 Z",
  },
  {
    id: 21,
    position: "8 სართულზე მარცხნიდან მეორე კიბის მერე ბინის პატარა ნაწილი",
    coordinates:
      "M872,284 L966,251 L898,114 L824,138 L820,157 L784,168 L777,152 L758,159 L825,299 Z",
  },
  {
    id: 33,
    position: "4 სართულზე ",
    coordinates:
      "M96,375 L171,352 L176,368 L223,353 L219,337 L309,308 L319,340 L325,338 L352,412 L361,409 L375,449 L140,526 Z",
  },
  {
    id: 34,
    position: "4 სართულზე ",
    coordinates:
      "M309,308 L313,320 L360,305 L356,291 L447,262 L454,276 L494,263 L493,247 L515,240 L570,384 L375,449 L361,409 L352,412 L325,338 L319,340 Z",
  },
  {
    id: 55,
    position: "5 სართულზე",
    coordinates:
      "M760,430 L789,493 L780,496 L773,522 L842,687 L887,722 L904,760 L994,728 L1009,762 L1015,759 L1030,793 L1174,742 L1184,733 L1166,699 L1180,682 L1135,592 L1218,562 L1224,552 L1220,544 L1242,536 L1260,514 L1234,464 L1248,459 L1255,446 L1216,367 L1300,338 L1316,312 L1270,228 L902,350 L938,428 L895,442 L872,392 Z",
  },
];
export const nikeaCoordinatesOnTheFloor = [
  {
    floorIds: [3],
    apartmentsPaths: [
      {
        id: 1,
        coordinates: "M277,188 L277,364 L422,364 L422,188 Z",
      },
      {
        id: 2,
        coordinates:
          "M277,188 L-36,188 L-36,357 L14,357 L14,367 L241,367 L241,325 L277,325 Z",
      },
      {
        id: 3,
        coordinates:
          "M-36,357 L14,357 L14,367 L241,367 L241,503 L77,503 L77,570 L-36,570 Z",
      },
      {
        id: 4,
        coordinates:
          "M241,503 L77,503 L77,570 L-36,570 L-38,805 L146,805 L146,598 L241,598 Z",
      },
      {
        id: 5,
        coordinates: "M146,805 L146,598 L241,598 L241,586 L280,586 L280,805 Z",
      },
      {
        id: 6,
        coordinates: "M280,586 L280,805 L422,805 L422,668 L477,668 L477,586 Z",
      },
      {
        id: 7,
        coordinates: "M477,586 L477,668 L546,668 L546,765 L686,765 L686,586 Z",
      },
      {
        id: 8,
        coordinates: "M686,586 L686,772 L821,772 L821,586 Z",
      },
      {
        id: 9,
        coordinates: "M821,586 L821,772 L959,772 L957,586 Z",
      },
      {
        id: 10,
        coordinates:
          "M957,586 L959,772 L1097,772 L1097,416 L959,416 L959,501 L953,501 L953,550 L957,550 Z",
      },
      {
        id: 11,
        coordinates: "M827,550 L827,382 L687,382 L687,550 Z",
      },

      {
        id: 12,
        coordinates: "M687,550 L687,382 L549,382 L549,550 Z",
      },
      {
        id: 13,
        coordinates: "M549,550 L549,382 L415,382 L415,502 L402,502 L402,549 Z",
      },
    ],
  },
  {
    floorIds: [4],
    apartmentsPaths: [
      {
        id: 1,
        coordinates: "M277,188 L277,364 L422,364 L422,188 Z",
      },
      {
        id: 2,
        coordinates:
          "M277,188 L-36,188 L-36,357 L14,357 L14,367 L241,367 L241,325 L277,325 Z",
      },
      {
        id: 3,
        coordinates:
          "M-36,357 L14,357 L14,367 L241,367 L241,503 L77,503 L77,570 L-36,570 Z",
      },
      {
        id: 4,
        coordinates:
          "M241,503 L77,503 L77,570 L-36,570 L-38,805 L146,805 L146,598 L241,598 Z",
      },
      {
        id: 5,
        coordinates: "M146,805 L146,598 L241,598 L241,586 L280,586 L280,805 Z",
      },
      {
        id: 6,
        coordinates: "M280,586 L280,805 L422,805 L422,668 L477,668 L477,586 Z",
      },
      {
        id: 7,
        coordinates: "M477,586 L477,668 L546,668 L546,765 L686,765 L686,586 Z",
      },
      {
        id: 8,
        coordinates: "M686,586 L686,772 L821,772 L821,586 Z",
      },
      {
        id: 9,
        coordinates: "M821,586 L821,772 L959,772 L957,586 Z",
      },
      {
        id: 10,
        coordinates:
          "M957,586 L959,772 L1097,772 L1097,416 L959,416 L959,501 L953,501 L953,550 L957,550 Z",
      },
      {
        id: 11,
        coordinates: "M827,550 L827,382 L687,382 L687,550 Z",
      },

      {
        id: 12,
        coordinates: "M687,550 L687,382 L549,382 L549,550 Z",
      },
      {
        id: 13,
        coordinates: "M549,550 L549,382 L415,382 L415,502 L402,502 L402,549 Z",
      },
    ],
  },
  {
    floorIds: [5],
    apartmentsPaths: [
      {
        id: 1,
        coordinates: "M267,196 L267,370 L412,370 L412,196 Z",
      },
      {
        id: 2,
        coordinates: "M267,196 L-48,196 L-48,370  L231,370 L231,329 L267,329 Z",
      },
      {
        id: 3,
        coordinates: "M-48,370 L231,370 L231,508 L-48,508 Z",
      },
      {
        id: 4,
        coordinates: "M231,508 L-48,508 L-48,815 L136,815 L136,604 L231,604 Z",
      },
      {
        id: 5,
        coordinates: "M136,815 L136,604 L231,604 L231,592 L270,592 270,815 Z",
      },
      {
        id: 6,
        coordinates: "M270,592 L270,815 L412,815 L412,676 L467,676 L467,592 Z",
      },
      {
        id: 7,
        coordinates: "M467,592 L467,676 L536,676 L536,770 L676,770 L676,592 Z",
      },
      {
        id: 8,
        coordinates: "M676,592 L676,780 L811,780 L811,592 Z",
      },
      {
        id: 9,
        coordinates: "M811,592 L811,780 L948,780 948,592 Z",
      },
      {
        id: 10,
        coordinates:
          "M948,592 948,780 L1087,780 L1087,424 L950,424 L950,503 944,503 L944,556 L948,556 Z",
      },
      {
        id: 11,
        coordinates: "M816,556 816,390 L677,390 L677,556 Z",
      },

      {
        id: 12,
        coordinates: "M677,556 L677,390 L539,390 L539,556 Z",
      },
      {
        id: 13,
        coordinates: "M539,556 L539,390 L405,390 L405,508 L392,508 L392,556 Z",
      },
    ],
  },
  {
    floorIds: [6],
    apartmentsPaths: [
      {
        id: 1,
        coordinates: "M263,202 L263,376 L404,376 L404,202 Z",
      },
      {
        id: 2,
        coordinates: "M261,202 L64,202 L32,376 L226,376 L226,334 L261,334 Z",
      },
      {
        id: 3,
        coordinates: "M32,376 L226,376 L226,508 L8,508 Z",
      },
      {
        id: 4,
        coordinates: "M226,508 L8,508 L-48,805 L132,805 L132,604 L226,604 Z",
      },
      {
        id: 5,
        coordinates: "M132,805 L132,602 L226,602 L226,592 L265,592 265,805 Z",
      },
      {
        id: 6,
        coordinates: "M265,592 L265,805 L404,805 L404,672 L460,672 L460,592 Z",
      },
      {
        id: 7,
        coordinates:
          "M460,592 L460,672 L525,672 L525,768 L657,768 L657,733 L663,733 L663,592 Z",
      },
      {
        id: 8,
        coordinates: "M663,592 L663,733 L657,733 L657,768 L932,768 L932,592 Z",
      },
      {
        id: 9,
        coordinates: "M800,555 800,392 L662,392 L662,555 Z",
      },
      {
        id: 10,
        coordinates: "M662,555 L662,392 L529,392 L529,555 Z",
      },
      {
        id: 11,
        coordinates: "M529,555 L529,392 L395,392 L395,508 L384,508 L384,555 Z",
      },
    ],
  },
  {
    floorIds: [7, 8, 9, 10, 11, 12],
    apartmentsPaths: [
      {
        id: 1,
        coordinates: "M288,212 L288,381 L429,381 L429,212 Z",
      },
      {
        id: 2,
        coordinates: "M286,212 L90,212 L58,381 L250,381 L250,334 L286,334 Z",
      },
      {
        id: 3,
        coordinates: "M56,386 L251,386 L251,516 L31,516 Z",
      },
      {
        id: 4,
        coordinates: "M251,516 L31,516 L-24,813 L157,813 L157,610 L251,610 Z",
      },
      {
        id: 5,
        coordinates: "M157,813 L157,610 L251,610 L251,600 L290,600 L290,813 Z",
      },
      {
        id: 6,
        coordinates: "M290,600 L290,813 L429,813 L429,680 L482,680 L482,600 Z",
      },
      {
        id: 7,
        coordinates:
          "M484,600 L484,680 L550,680 L550,774 L682,774 L682,741 L688,741 L688,600 Z",
      },
      {
        id: 8,
        coordinates: "M686,600 L688,741 L682,741 L682,772 L821,772 L821,600 Z",
      },
      {
        id: 9,
        coordinates: "M821,600 L821,774 L985,774 L985,564 L957,564 L957,600 Z",
      },
      {
        id: 10,
        coordinates: "M823,563 L823,402 L688,402 L688,563 Z",
      },
      {
        id: 11,
        coordinates: "M688,563 L688,402 L554,402 L554,563 Z",
      },
      {
        id: 12,
        coordinates: "M554,563 L554,402 L420,402 L420,516 L410,516 L410,563 Z",
      },
    ],
  },
];

export const ApartmentsTypes = {
  greenhome: {
    apartmentsArray: [
      {
        id: 1,
        name: "oneBedroom",
        label: "1 საძინებლიანი",
        img: render4849,
        subType: [
          {
            id: "xs",
            label: "ეკონომი",
            size: 48.5,
            rooms: [
              { label: "საერთო ოთახი", size: 25.79 },
              { label: "საძინებელი", size: 12.5 },
              { label: "სველი წერტილი", size: 6 },
              { label: "ტერასა", size: 4.2 },
            ],
            renders: [render4849],
            image360: "",
          },
          {
            id: "sm",
            label: "ეკონომი",
            size: 49.15,
            rooms: [
              { label: "საერთო ოთახი", size: 25.25 },
              { label: "საძინებელი", size: 13.7 },
              { label: "სველი წერტილი", size: 6 },
              { label: "ტერასა", size: 4.2 },
            ],
            renders: [render4849],
            image360: "",
          },
          {
            id: "md",
            label: "კომფორტი",
            size: 50.76,
            rooms: [
              { label: "საერთო ოთახი", size: 25.46 },
              { label: "საძინებელი", size: 16.5 },
              { label: "სველი წერტილი", size: 4 },
              { label: "ტერასა", size: 4.8 },
            ],
            renders: [render50],
            image360: "",
          },
          {
            id: "lg",
            label: "ლუქსი",
            size: 62.46,
            rooms: [
              { label: "საერთო ოთახი", size: 36.3 },
              { label: "საძინებელი", size: 13.2 },
              { label: "სველი წერტილი", size: 6 },
              { label: "ტერასა", size: 7 },
            ],
            renders: [render60],
            image360: "https://thatonearchitect.github.io/62.5-sq.m/",
          },
          {
            id: "xl",
            label: "ლუქსი",
            size: 62.87,
            rooms: [
              { label: "საერთო ოთახი", size: 36.89 },
              { label: "საძინებელი", size: 13.5 },
              { label: "სველი წერტილი", size: 8 },
              { label: "ტერასა", size: 4.4 },
            ],
            renders: [render62one, render62two],
            image360:
              "https://www.coohom.com/pub/tool/panorama/show?obsPlanId=3FO3PGYJYLCQ&locale=en_US",
          },
        ],
      },
      {
        id: 2,
        name: "twoBedroom",
        label: "2 საძინებლიანი",
        img: render80,
        subType: [
          {
            id: "xs",
            label: "ეკონომი",
            size: 70.67,

            rooms: [
              { label: "საერთო ოთახი", size: 29.05 },
              { label: "საძინებელი 1", size: 11.9 },
              { label: "საძინებელი 2", size: 12.4 },
              { label: "სველი წერტილი", size: 6 },
              { label: "ტერასა 1", size: 7 },
              { label: "ტერასა 2", size: 4.3 },
            ],
            renders: [render87],
            image360: "",
          },
          {
            id: "sm3floor",
            label: "ეკონომი",
            size: 78.23,
            rooms: [],
            renders: [render80],
            image360: "",
          },
          {
            id: "sm",
            label: "ეკონომი",
            size: 80.72,
            rooms: [
              { label: "ჰოლი", size: 14 },
              { label: "საერთო ოთახი", size: 25.22 },
              { label: "საძინებელი 1", size: 13.5 },
              { label: "საძინებელი 2", size: 13 },
              { label: "სველი წერტილი", size: 7 },
              { label: "ტერასა", size: 8 },
            ],
            renders: [render80],
            image360: "",
          },
          {
            id: "md",
            label: "სტანდარტი",
            size: 87,
            rooms: [
              { label: "საერთო ოთახი", size: 40.78 },
              { label: "საძინებელი 1", size: 14 },
              { label: "საძინებელი 2", size: 15 },
              { label: "სველი წერტილი", size: 6 },
              { label: "ტერასა 1", size: 4.2 },
              { label: "ტერასა 2", size: 7 },
            ],
            renders: [render87],
            image360: "",
          },

          {
            id: "xl",
            label: "ლუქსი",
            size: 114.95,
            rooms: [
              { label: "საერთო ოთახი", size: 50.95 },
              { label: "საძინებელი 1", size: 20 },
              { label: "საძინებელი 2", size: 28 },
              { label: "სველი წერტილი", size: 8 },
              { label: "ტერასა", size: 8 },
            ],
            renders: [render115],
            image360:
              "https://www.coohom.com/pub/tool/panorama/show?obsPlanId=3FO3PH1CH850&locale=en_US",
          },
          {
            id: "2xl",
            label: "ლუქსი",
            size: 119.18,
            rooms: [
              // { label: "საერთო ოთახი", size: 60.21 },
              // { label: "საძინებელი 1", size: 15 },
              // { label: "საძინებელი 2", size: 16.9 },
              // { label: "სველი წერტილი 1", size: 7 },
              // { label: "სველი წერტილი 1", size: 4 },
              // { label: "ტერასა 1", size: 8 },
              // { label: "ტერასა 2", size: 8 },
            ],
            renders: [render119],
            image360:
              "https://www.coohom.com/pub/tool/panorama/show?obsPlanId=3FO3PGWCKJSJ&locale=en_US",
          },
        ],
      },
      {
        id: 3,
        name: "threeBedroom",
        label: "3 საძინებლიანი",
        img: render125One,
        subType: [
          {
            id: "sm",
            label: "ლუქსი",
            size: 93,
            rooms: [
              { label: "საერთო ოთახი", size: 37.74 },
              { label: "საძინებელი 1", size: 17 },
              { label: "საძინებელი 2", size: 9 },
              { label: "საძინებელი 3", size: 13.5 },
              { label: "სველი წერტილი", size: 7 },
              { label: "ტერასა 1", size: 4.5 },
              { label: "ტერასა 2", size: 4.2 },
            ],
            renders: [render93],
            image360: "",
          },
          {
            id: "md",
            label: "ლუქსი",
            size: 125.15,
            rooms: [
              { label: "საერთო ოთახი", size: 49.41 },
              { label: "საძინებელი 1", size: 14 },
              { label: "საძინებელი 2", size: 17 },
              { label: "საძინებელი 3", size: 17 },
              { label: "სველი წერტილი", size: 7.5 },
              { label: "ტერასა 1", size: 10 },
              { label: "ტერასა 2", size: 10 },
            ],
            renders: [render125One],
            image360:
              "https://www.coohom.com/pub/tool/panorama/show?obsPlanId=3FO3MEAJHCNG&locale=en_US",
          },
          {
            id: "lg",
            label: "ლუქსი",
            size: 127.93, // 2 სართულზე 1-7 ბინები გაერთიანებული
            rooms: [],
            renders: [render127one, render127three, render127four],
            imageMedical:
              "https://www.coohom.com/pub/tool/panorama/show?obsPlanId=3FO3MGC2OFES&locale=en_US",
            imageOffice:
              "https://www.coohom.com/pub/tool/panorama/show?obsPlanId=3FO3METJYH1H&locale=en_US",
          },
          {
            id: "2xl",
            label: "ლუქსი",
            size: 160, //ეს არის მერვე სართულზე დიდი ბინა
            rooms: [],
          },
          {
            id: "xl",
            label: "ლუქსი",
            size: 138.83, //ეს არის მესამე სართულზე რომ გაერთიანებული ბინაა მარცხენა მხარეს
            rooms: [],
            renders: [render138],
          },
        ],
      },
    ],
  },
  nikea: {
    apartmentsArray: [
      {
        id: 1,
        name: "oneBedroom",
        label: "1 საძინებლიანი",
        img: [NikeaApartmentRenders[55]],
        subType: [
          {
            id: "49.4",
            label: "ეკონომი",
            size: 49.4,
            rooms: [
              { label: "მისაღები", size: 26.2 },
              { label: "საძინებელი", size: 13.1 },
              { label: "სველი წერტილი", size: 5.2 },
              { label: "ტერასა", size: 4.9 },
            ],
            renders: [NikeaApartmentRenders[50]],
            image360: "",
          },
          {
            id: "49.9",
            label: "ეკონომი",
            size: 49.9,
            rooms: [
              { label: "მისაღები", size: 27 },
              { label: "საძინებელი", size: 12.9 },
              { label: "სველი წერტილი", size: 5.1 },
              { label: "ტერასა", size: 4.9 },
            ],
            renders: [NikeaApartmentRenders[50]],
            image360: "",
          },
          {
            id: "50",
            label: "კომფორტი",
            size: 50,
            rooms: [
              { label: "მისაღები", size: 26.6 },
              { label: "საძინებელი", size: 12.8 },
              { label: "სველი წერტილი", size: 5.8 },
              { label: "ტერასა", size: 4.8 },
            ],
            renders: [NikeaApartmentRenders[50]],
            image360: "",
          },
          {
            id: "52.5",
            label: "კომფორტი",
            size: 52.5,
            rooms: [
              { label: "მისაღები", size: 24.5 },
              { label: "საძინებელი", size: 17.1 },
              { label: "სველი წერტილი", size: 6.1 },
              { label: "ტერასა", size: 4.8 },
            ],
            renders: [],
            image360: "",
          },
          {
            id: "55",
            label: "კომფორტი",
            size: 55,
            rooms: [
              { label: "მისაღები", size: 24.8 },
              { label: "საძინებელი", size: 18 },
              { label: "სველი წერტილი", size: 6.1 },
              { label: "ტერასა", size: 6.1 },
            ],
            renders: [NikeaApartmentRenders[55]],
            image360: "",
          },
          {
            id: "55.3",
            label: "ლუქსი",
            size: 55.3,
            rooms: [
              { label: "მისაღები", size: 26.4 },
              { label: "საძინებელი", size: 16.1 },
              { label: "სველი წერტილი", size: 6.4 },
              { label: "ტერასა", size: 6.4 },
            ],
            renders: [NikeaApartmentRenders[55.3]],
            image360: "",
          },
          {
            id: "62.1",
            label: "დელუქსი",
            size: 62.1,
            rooms: [
              { label: "მისაღები", size: 33.3 },
              { label: "საძინებელი", size: 16.8 },
              { label: "სველი წერტილი", size: 6.8 },
              { label: "ტერასა", size: 5.2 },
            ],
            renders: [],
            image360: "",
          },
          {
            id: "62.7",
            label: "დელუქსი",
            size: 62.7,
            rooms: [
              { label: "მისაღები", size: 31 },
              { label: "საძინებელი", size: 18.8 },
              { label: "სველი წერტილი", size: 7.1 },
              { label: "ტერასა", size: 5.8 },
            ],
            renders: [NikeaApartmentRenders[62.7]],
            image360: "",
          },
          {
            id: "67.9",
            label: "დელუქსი",
            size: 67.9,
            rooms: [
              { label: "მისაღები", size: 32.1 },
              { label: "საძინებელი", size: 16.4 },
              { label: "სველი წერტილი", size: 5.9 },
              { label: "ტერასა", size: 13.5 },
            ],
            renders: [],
            image360: "",
          },
          {
            id: "82.6",
            label: "დელუქსი",
            size: 82.6,
            rooms: [
              { label: "მისაღები", size: 31 },
              { label: "საძინებელი 1", size: 18.5 },
              { label: "სველი წერტილი", size: 7.2 },
              { label: "ტერასა", size: 25.9 },
            ],
            renders: [],
            image360: "",
          },
        ],
      },
      {
        id: 2,
        name: "twoBedroom",
        label: "2 საძინებლიანი",
        img: [NikeaApartmentRenders[124.5]],
        subType: [
          {
            id: "67",
            label: "ეკონომი",
            size: 67,
            rooms: [
              { label: "მისაღები", size: 28.5 },
              { label: "საძინებელი 1", size: 12.5 },
              { label: "საძინებელი 2", size: 14.1 },
              { label: "სველი წერტილი", size: 7.3 },
              { label: "ტერასა", size: 4.7 },
            ],
            renders: [NikeaApartmentRenders[67]],
            image360: "",
          },
          {
            id: "77.5",
            label: "სტანდარტი",
            size: 77.5,
            rooms: [
              { label: "მისაღები", size: 40.5 },
              { label: "საძინებელი 1", size: 12.2 },
              { label: "საძინებელი 2", size: 13.1 },
              { label: "სველი წერტილი", size: 6.4 },
              { label: "ტერასა", size: 5.3 },
            ],
            renders: [NikeaApartmentRenders[77.5]],
            image360: "",
          },

          {
            id: "81.4",
            label: "კომფორტი",
            size: 81.4,
            rooms: [
              { label: "მისაღები", size: 38.3 },
              { label: "საძინებელი 1", size: 13.8 },
              { label: "საძინებელი 2", size: 14.8 },
              { label: "სველი წერტილი", size: 8.3 },
              { label: "ტერასა", size: 6.2 },
            ],
            renders: [NikeaApartmentRenders[81.4]],
            image360: "",
          },
          {
            id: "100.2",
            label: "ლუქსი",
            size: 100.2,
            rooms: [
              { label: "მისაღები", size: 44.5 },
              { label: "საძინებელი 1", size: 17.4 },
              { label: "საძინებელი 2", size: 17.6 },
              { label: "გარდერობი", size: 7 },
              { label: "სველი წერტილი", size: 7.2 },
              { label: "ტერასა", size: 6.5 },
            ],
            renders: [NikeaApartmentRenders[100.2]],
            image360: "",
          },
          {
            id: "118.1",
            label: "ლუქსი",
            size: 118.1,
            rooms: [
              { label: "მისაღები", size: 38.4 },
              { label: "საძინებელი 1", size: 13.9 },
              { label: "საძინებელი 2", size: 14.7 },
              { label: "სველი წერტილი", size: 7.8 },
              { label: "ტერასა", size: 43.3 },
            ],
            renders: [],
            image360: "",
          },
          {
            id: "124.5",
            label: "დელუქსი",
            size: 124.5,
            rooms: [
              { label: "მისაღები", size: 53.1 },
              { label: "საძინებელი 1", size: 18.4 },
              { label: "საძინებელი 2", size: 15.5 },
              { label: "გარდერობი", size: 5 },
              { label: "სველი წერტილი 1", size: 8.3 },
              { label: "სველი წერტილი 2", size: 3.1 },
              { label: "ტერასა", size: 21.1 },
            ],
            renders: [NikeaApartmentRenders[124.5]],
            image360: "",
          },
        ],
      },
      {
        id: 3,
        name: "threeBedroom",
        label: "3 საძინებლიანი",
        img: [NikeaApartmentRenders[123.8]],
        subType: [
          {
            id: "112.6",
            label: "ეკონომი",
            size: 112.6,
            rooms: [
              { label: "მისაღები", size: 50.7 },
              { label: "საძინებელი 1", size: 14.1 },
              { label: "საძინებელი 2", size: 16.8 },
              { label: "საძინებელი 3", size: 16.1 },
              { label: "სველი წერტილი", size: 5.3 },
              { label: "ტერასა", size: 9.6 },
            ],
            renders: [NikeaApartmentRenders[112.6]],
            image360: "",
          },
          {
            id: "117.6",
            label: "სტანდარტი",
            size: 117.6,
            rooms: [
              { label: "მისაღები", size: 49.4 },
              { label: "საძინებელი 1", size: 13.9 },
              { label: "საძინებელი 2", size: 13.7 },
              { label: "საძინებელი 3", size: 13.7 },

              { label: "სველი წერტილი", size: 7.9 },
              { label: "ტერასა", size: 19 },
            ],
            renders: [NikeaApartmentRenders[117]],
            image360: "",
          },
          {
            id: "123.8",
            label: "ლუქსი",
            size: 123.8,
            rooms: [
              { label: "მისაღები", size: 47.3 },
              { label: "საძინებელი 1", size: 15.3 },
              { label: "საძინებელი 2", size: 13.8 },
              { label: "საძინებელი 3", size: 17.4 },
              { label: "გარდერობი", size: 6.4 },
              { label: "სველი წერტილი", size: 8.2 },
              { label: "ტერასა", size: 15.4 },
            ],
            renders: [NikeaApartmentRenders[123.8]],
          },
          {
            id: "141.5",
            label: "ლუქსი",
            size: 141.5,
            rooms: [
              { label: "მისაღები", size: 47.3 },
              { label: "საძინებელი 1", size: 15.3 },
              { label: "საძინებელი 2", size: 13.4 },
              { label: "საძინებელი 2", size: 15.7 },
              { label: "სველი წერტილი 1", size: 8.2 },
              { label: "სველი წერტილი 2", size: 6.3 },
              { label: "ტერასა", size: 35.3 },
            ],
            renders: [],
          },
          {
            id: "213.3",
            label: "ლუქსი",
            size: 213.3,
            rooms: [
              { label: "მისაღები", size: 44.1 },
              { label: "საძინებელი 1", size: 18.7 },
              { label: "საძინებელი 2", size: 18.9 },
              { label: "საძინებელი 2", size: 18.1 },
              { label: "სველი წერტილი", size: 7.2 },
              { label: "ტერასა", size: 106.2 },
            ],
            renders: [],
          },
        ],
      },
    ],
  },
};
